import * as Yup from 'yup';

// eslint-disable-next-line import/prefer-default-export
export const createOrganizationValidationSchema = Yup.object().shape({
  name: Yup.string().required('organization.validationErrors.nameRequired'),
  englishName: Yup.string().required('organization.validationErrors.englishNameRequired'),
  chief: Yup.string().required('organization.validationErrors.chiefRequired'),
  phone: Yup.string(),
  fax: Yup.string(),
  email: Yup.string().email('organization.validationErrors.emailInvalid'),
  address: Yup.string(),
  bankAccount: Yup.string(),
  bank: Yup.string(),
  inVnuHcm: Yup.number()
    .integer()
    .oneOf([0, 1], 'organization.validationErrors.inVnuHcmRequired')
    .required('organization.validationErrors.inVnuHcmRequired'),
  code: Yup.string(),
});
